window.Backbone = require('backbone');

window.Backbone.$ = window.$;

require('../../modules/support/frontend/support');

require("./vendor_modules/jQuery/jQuery-ui-1.10.1.min.js");

require("./vendor_modules/jQuery/datetimepicker.js");

require("./vendor_modules/jQuery/pagination/jQuery-pagination-2.2.js");

require("./vendor_modules/mustache-0.7.2.js");

require('../../node_modules/jquery.inputmask/dist/inputmask/jquery.inputmask.js');

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9jb3JlL2Zyb250ZW5kL3N1cHBvcnQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9jb3JlL2Zyb250ZW5kL3N1cHBvcnQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxRQUFQLEdBQWtCLE9BQUEsQ0FBUSxVQUFSOztBQUNsQixNQUFNLENBQUMsUUFBUSxDQUFDLENBQWhCLEdBQW9CLE1BQU0sQ0FBQzs7QUFDM0IsT0FBQSxDQUFRLHdDQUFSOztBQUNBLE9BQUEsQ0FBUSxpREFBUjs7QUFDQSxPQUFBLENBQVEsMkNBQVI7O0FBQ0EsT0FBQSxDQUFRLDZEQUFSOztBQUNBLE9BQUEsQ0FBUSxvQ0FBUjs7QUFDQSxPQUFBLENBQVEsd0VBQVIifQ==
